import { useEffect, useRef, useState } from 'react';

type UseDelayedEventProps = {
  milliseconds?: number;
  onEnded?: () => void;
};

type UseDelayedEvent = (props?: UseDelayedEventProps) => {
  activate: (props?: UseDelayedEventProps) => () => void;
  isActive: boolean;
  activated: boolean;
  clear: () => void;
};

export const useDelayedEvent: UseDelayedEvent = ({
  milliseconds: defaultMilliseconds,
  onEnded: defaultOnEnded,
} = {}) => {
  const [waitingFor, setWaitingFor] = useState<number | undefined>();
  const timeoutRef = useRef<number>(undefined);
  const wasActiveRef = useRef<boolean>(false);

  useEffect(
    () => (): void => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
    },
    []
  );

  const clear = (onEnded = defaultOnEnded): void => {
    setWaitingFor(undefined);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = undefined;
    onEnded?.();
    defaultOnEnded?.();
  };

  // eslint-disable-next-line react-hooks/refs
  return {
    activate: ({ milliseconds, onEnded }: UseDelayedEventProps = {}) => {
      const timeToWait = milliseconds || defaultMilliseconds || 1000;

      wasActiveRef.current = true;
      setWaitingFor(timeToWait);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => clear(onEnded), timeToWait) as any;
      return () => clear(onEnded);
    },
    isActive: waitingFor !== undefined,
    // Was activateFor has been called at least once?
    // (useful for cases like closing a drawer and not destroying overlay while drawer is closing)
    // eslint-disable-next-line react-hooks/refs
    activated: wasActiveRef.current,
    clear,
  };
};
